import 'globals';
import {Collapse} from "bootstrap";

/**
 * Toggle dropdown navigation on hover
 */
const toggleDropdown = () => {
    const navbarDropdownItems = document.querySelectorAll('nav .nav-item.dropdown');

    if (navbarDropdownItems.length) {
        navbarDropdownItems.forEach((navbarItem) => {
            const dropdownToggle = navbarItem.querySelector('.dropdown-toggle');

            if (dropdownToggle) {
                const dropdownDesktop = dropdownToggle.parentNode.querySelector('.dropdown-desktop-navigation');

                navbarItem.addEventListener('mouseover', () => {
                    if (window.Viewport().currentViewport.size > 992) {
                        dropdownToggle.classList.add('show');
                        dropdownDesktop.classList.add('show');
                    }
                }, {passive: true});

                navbarItem.addEventListener('mouseout', () => {
                    if (window.Viewport().currentViewport.size > 992) {
                        dropdownToggle.classList.remove('show');
                        dropdownDesktop.classList.remove('show');
                    }
                }, {passive: true});

                navbarItem.querySelector('a').addEventListener('click', (e) => {
                    window.location = e.target.getAttribute('href');
                }, {passive: false});
            }
        });
    }
}

const switchMobileNavigation = () => {
    const navbarToggler = document.getElementById('navbar-toggler');
    const navbarCollapseEl = document.querySelector('#navbarSupportedContent');
    const navbarCollapse = new Collapse(navbarCollapseEl, {
        toggle: false
    });

    navbarToggler.addEventListener('click', () => {
        if (navbarCollapseEl.classList.contains('show')) {
            navbarToggler.setAttribute('aria-expanded', false);
            document.body.classList.remove('navbar-expanded');
            navbarCollapse.hide();
        }
        else {
            navbarToggler.setAttribute('aria-expanded', true);
            document.body.classList.add('navbar-expanded');
            navbarCollapse.show();
        }
    }, {passive: false});
}

window.PageLoadedQueue.addFunction(function() {
    toggleDropdown();
    switchMobileNavigation();
});
